export enum VerificationSteps {
  "DOB_AUTH" = "dob_auth",
  "RECEIPT" = "receipt",
  "HOSPITAL_CONFIRMATION" = "hospital_confirmation",
}
